<h2 mat-dialog-title>Bloquer un numéro INAMI</h2>

<form [formGroup]="form">
  <div mat-dialog-content class="dialog-content">
    <mat-form-field appearance="outline">
      <mat-label>Numéro INAMI</mat-label>
      <input matInput formControlName="encodedNihii" />
      @if (hasNihiiError) {
        <mat-error>
          @if (encodedNihiiControl.hasError('required')) {
            L'INAMI est obligatoire.
          } @else if (encodedNihiiControl.hasError('nihiiLength')) {
            L'INAMI normalisé doit contenir au moins 8 chiffres.
          } @else if (encodedNihiiControl.hasError('nihiiCheckDigit')) {
            L'INAMI est invalide.
          }
        </mat-error>
      }
    </mat-form-field>

    <p class="normalized-preview">
      Valeur de blocage : <strong>{{ normalizedNihii || 'Aucun' }}</strong>
    </p>

    <mat-form-field appearance="outline">
      <mat-label>Type de blocage</mat-label>
      <mat-select formControlName="overrideType">
        @for (option of overrideTypes; track option.value) {
          <mat-option [value]="option.value">{{ option.label }}</mat-option>
        }
      </mat-select>
      @if (hasOverrideTypeError) {
        <mat-error>Le type de blocage est obligatoire.</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Raison</mat-label>
      <textarea matInput formControlName="reason" maxlength="255" rows="4"></textarea>
      @if (hasReasonError) {
        <mat-error>
          @if (reasonControl.hasError('required')) {
            La raison est obligatoire.
          } @else if (reasonControl.hasError('minlength')) {
            La raison doit contenir au moins 3 caractères.
          }
        </mat-error>
      }
    </mat-form-field>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button type="button" (click)="closeDialog()">Annuler</button>
    <button mat-flat-button color="primary" type="button" [disabled]="!canSubmit" (click)="addNihiiOverride()">Bloquer l'INAMI</button>
  </div>
</form>
